import { render, staticRenderFns } from "./UserSuggestion.vue?vue&type=template&id=56d44a3d&scoped=true&"
import script from "./UserSuggestion.vue?vue&type=script&lang=js&"
export * from "./UserSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d44a3d",
  null
  
)

export default component.exports